import React from 'react';
import styled from 'styled-components';
import { EssCards } from '../../../types/EssCards';
import { getTabLabel } from './essCardTabsHelper';

interface EssCardTabsProps {
    cards: EssCards[];
    activeId: string;
    onChange: (id: string) => void;
    essLabel: string;
}

const TabsContainer = styled.div`
    flex-direction: row;
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 50;
    background: ${({ theme }) => theme.contentBackground};
    border-bottom: 1px solid ${({ theme }) => theme.cardBorder};
    padding-bottom: 8px;
`;

const Tab = styled.button<{ $active: boolean }>`
    flex: 1 1 50%;
    max-width: 50%;
    padding: 10px 12px;
    background: ${({ $active, theme }) => ($active ? theme.contentBackground : 'transparent')};
    color: ${({ theme }) => theme.primaryContentText};
    border: 0;
    border-right: 1px solid ${({ theme }) => theme.cardBorder};
    border-bottom: 3px solid ${({ $active, theme }) => ($active ? theme.primaryContentText : 'transparent')};
    font: inherit;
    font-weight: ${({ $active }) => ($active ? 'bold' : 'normal')};
    opacity: ${({ $active }) => ($active ? 1 : 0.6)};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    &:last-child { border-right: 0; }
`;

const EssCardTabs: React.FC<EssCardTabsProps> = ({ cards, activeId, onChange, essLabel }) => (
    <TabsContainer className="essCardTabs" role="tablist">
        {cards.map(card => {
            const isActive = card.id === activeId;

            return (
                <Tab
                    key={card.id}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    $active={isActive}
                    onClick={() => onChange(card.id)}
                >
                    {getTabLabel(card, essLabel)}
                </Tab>
            );
        })}
    </TabsContainer>
);

export default EssCardTabs;
